import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { RuntimeGameProvider } from './state/runtimeGameProvider';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <RuntimeGameProvider>
        <App />
      </RuntimeGameProvider>
    </BrowserRouter>
  </StrictMode>,
);
